// extracted by mini-css-extract-plugin
export default {"sidebarWrapper":"deliverySidebar_sidebarWrapper__h6Xag","wrapper":"deliverySidebar_wrapper__-Q6Gz","selected":"deliverySidebar_selected__lXZRJ"};